// Components==============
import { motion } from 'framer-motion';
import React from 'react';
// =========================

const opacityValues = [0, 0.5, 0.5, 0];
const opacityTimes = [0, 0.2, 0.8, 0.95];
// const xValues = ;
const xTimes = [0, 1, 1];

const testing = false;

// Duration for each cloud

const cloudSpeeds = {
    slow: 45,
    slow2: 47,
    medium: 40,
    fast: 36,
};
const cloudDurations = {
    red: cloudSpeeds.medium,
    blue: cloudSpeeds.slow,
    green: cloudSpeeds.fast,
    yellow: cloudSpeeds.fast + 1,
    pink: cloudSpeeds.slow + 2,
};

const Clouds = React.memo(() => (
    <>
        {/* Red */}
        <motion.path
            animate={{
                x: [-1500, 2500, -1500],
                opacity: opacityValues,
            }}
            transition={{
                x: {
                    duration: cloudDurations.red,
                    times: xTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                    delay: 3,
                },
                opacity: {
                    duration: cloudDurations.red,
                    times: opacityTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                    delay: 3,
                },
            }}
            d="m3835.38,326.83h0c0,18.07,14.64,32.71,32.71,32.71h292.06c18.06,0,32.71,14.64,32.71,32.71h0c0,18.06-14.64,32.71-32.71,32.71h-537.47c-18.06,0-32.71-14.64-32.71-32.71h0c0-18.06-14.64-32.71-32.71-32.71h-129.05c-18.06,0-32.71-14.64-32.71-32.71h0c0-18.07,14.64-32.71,32.71-32.71h374.45c18.06,0,32.71,14.64,32.71,32.71Z"
            fill={`${testing ? '#ff0000' : '#fff'}`}
            opacity=".5"
            strokeWidth="0"
        />
        {/* Blue */}
        <motion.path
            animate={{
                x: [-2000, 2200, -2000],
                opacity: opacityValues,
            }}
            transition={{
                x: {
                    duration: cloudDurations.blue,
                    times: xTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                },
                opacity: {
                    duration: cloudDurations.blue,
                    times: opacityTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                },
            }}
            d="m4553.35,271.85v1.98c0,10.34-8.38,18.72-18.72,18.72h-114.2c-10.34,0-18.72,8.38-18.72,18.72v1.98c0,10.34,8.38,18.72,18.72,18.72h173.28c10.34,0,18.72-8.38,18.72-18.72v-1.98c0-10.34,8.38-18.72,18.72-18.72h112.05c10.34,0,18.72,8.38,18.72,18.72v1.98c0,10.34-8.38,18.72-18.72,18.72h-49.1c-10.34,0-18.72,8.38-18.72,18.72v1.98c0,10.34-8.38,18.72-18.72,18.72h-325.8c-10.34,0-18.72-8.38-18.72-18.72v-1.98c0-10.34-8.38-18.72-18.72-18.72h-47.16c-10.34,0-18.72-8.38-18.72-18.72v-1.98c0-10.34-8.38-18.72-18.72-18.72h0c-10.34,0-18.72-8.38-18.72-18.72v-1.98c0-10.34,8.38-18.72,18.72-18.72h325.8c10.34,0,18.72,8.38,18.72,18.72Z"
            fill={`${testing ? '#002aff' : '#fff'}`}
            opacity=".5"
            strokeWidth="0"
        />
        {/* Green */}
        <motion.path
            animate={{
                x: [-1500, 2500, -1500],
                opacity: opacityValues,
            }}
            transition={{
                x: {
                    duration: cloudDurations.green,
                    times: xTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                    delay: 20,
                },
                opacity: {
                    duration: cloudDurations.green,
                    times: opacityTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                    delay: 20,
                },
            }}
            d="m3019,377.07v3.28c0,17.16-13.91,31.07-31.07,31.07h-189.55c-17.16,0-31.07,13.91-31.07,31.07v3.28c0,17.16,13.91,31.07,31.07,31.07h287.61c17.16,0,31.07-13.91,31.07-31.07v-3.28c0-17.16,13.91-31.07,31.07-31.07h185.98c17.16,0,31.07,13.91,31.07,31.07v3.28c0,17.16-13.91,31.07-31.07,31.07h-81.49c-17.16,0-31.07,13.91-31.07,31.07v3.28c0,17.16-13.91,31.07-31.07,31.07h-540.75c-17.16,0-31.07-13.91-31.07-31.07v-3.28c0-17.16-13.91-31.07-31.07-31.07h-78.28c-17.16,0-31.07-13.91-31.07-31.07v-3.28c0-17.16-13.91-31.07-31.07-31.07h0c-17.16,0-31.07-13.91-31.07-31.07v-3.28c0-17.16,13.91-31.07,31.07-31.07h540.75c17.16,0,31.07,13.91,31.07,31.07Z"
            fill={`${testing ? '#00ff55' : '#fff'}`}
            opacity=".5"
            strokeWidth="0"
        />
        {/* Yellow */}
        <motion.path
            animate={{
                x: [-3800, 1200, -3800],
                opacity: opacityValues,
            }}
            transition={{
                x: {
                    duration: cloudDurations.yellow,
                    times: xTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                    delay: 16,
                },
                opacity: {
                    duration: cloudDurations.yellow,
                    times: opacityTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                    delay: 16,
                },
            }}
            d="m6316.38,320h0c0-18.06-14.64-32.71-32.71-32.71h-537.47c-18.06,0-32.71,14.64-32.71,32.71h0c0,18.06,14.64,32.71,32.71,32.71h124.41c18.06,0,32.71,14.64,32.71,32.71h0c0,18.06-14.64,32.71-32.71,32.71h-326.97c-18.06,0-32.71,14.64-32.71,32.71h0c0,18.07,14.64,32.71,32.71,32.71h537.47c18.06,0,32.71-14.64,32.71-32.71h0c0-18.07,14.64-32.71,32.71-32.71h326.97c18.06,0,32.71-14.64,32.71-32.71h0c0-18.06-14.64-32.71-32.71-32.71h-124.41c-18.06,0-32.71-14.64-32.71-32.71Z"
            fill={`${testing ? '#bfff00' : '#fff'}`}
            opacity=".5"
            strokeWidth="0"
        />
        {/* Pink */}
        <motion.g
            animate={{
                x: [-2000, 2500, -2000],
                opacity: opacityValues,
            }}
            transition={{
                x: {
                    duration: cloudDurations.pink,
                    times: xTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                },
                opacity: {
                    duration: cloudDurations.pink,
                    times: opacityTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                },
            }}
        >
            <path
                d="m4860.64,525.9h0c0,9.03-7.32,16.35-16.35,16.35h-146.03c-9.03,0-16.35,7.32-16.35,16.35h0c0,9.03,7.32,16.35,16.35,16.35h268.73c9.03,0,16.35-7.32,16.35-16.35h0c0-9.03,7.32-16.35,16.35-16.35h64.52c9.03,0,16.35-7.32,16.35-16.35h0c0-9.03-7.32-16.35-16.35-16.35h-187.23c-9.03,0-16.35,7.32-16.35,16.35Z"
                fill={`${testing ? '#ff00f2' : '#fff'}`}
                opacity=".5"
                strokeWidth="0"
            />
        </motion.g>

        {/* <motion.g
            animate={{
                x: [-1500, 2500, -1500],
                opacity: opacityValues,
            }}
            transition={{
                x: {
                    duration: 21,
                    times: xTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                },
                opacity: {
                    duration: 21,
                    times: opacityTimes,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                },
            }}
        >
            <polygon
                points="4944.48 2106.97 4961 2102.18 4973.78 2102.53 4961 2110.99 4944.48 2106.97"
                fill="#ebd0b6"
                strokeWidth="0"
            />
            <path
                d="m3777.84,870.79l108.77-140c27.35-35.2,73.2-50.49,116.2-38.75l54.33,14.83-279.3,163.92Z"
                fill="#fff"
                strokeWidth="0"
            />
        </motion.g> */}
    </>
));

Clouds.displayName = 'Clouds';
export default Clouds;
